import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import { Spinner } from "reactstrap";
import mixpanel from "mixpanel-browser";

import { removeNoNumbersCharactersFromChangeEvent } from "../../../Utils/inputFunctions";
import { api } from "../../../Services/Api";
import { InputGroup } from "../../../Theme";
import phoneMask from "../../../Utils/phoneMask";
import { Form, ContainerButtonSubmit } from "../styles";
import LinkInput from "../LinkInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

function BasicConfig() {
  const dispatch = useDispatch();

  const store = useSelector((state) => state.store);

  const [whatsapp, setWhatsapp] = React.useState(store.whatsapp);
  const [alias, setAlias] = React.useState(store.alias);

  const [isErrorSlug, setIsErrorSlug] = React.useState(false);
  const [slugErrorMessage, setSlugErrorMessage] = React.useState("");
  const [loading, setLoading] = React.useState(0);

  function handleSubmitBasicConfig(event) {
    event.preventDefault();
    handleSubmit(1);
  }

  function handleAliasChange(event) {
    const aliasValue = event.target.value;
    setAlias(aliasValue);
  }

  function handleWhatsappChange(event) {
    const whatsappValue = event.target.value;
    setWhatsapp(whatsappValue);
  }

  const insertDDI = React.useCallback((event) => {
    event.target.value = "55" + event.target.value.substring(2, 13);
    return event;
  });

  function handleSubmit(btn) {
    setIsErrorSlug(false);
    validateAlias().then((isValid) => {
      if (isValid) {
        mixpanel.track("Set Link");
        setLoading(btn);
        dispatch({ type: "SET_LOADING" });
        dispatch({ type: "SAVE_SERVICE_BASIC_CONFIG", whatsapp, alias });
      }
    });
  }

  async function validateAlias() {
    if (alias === "menu.mindi.com.br/") {
      setSlugErrorMessage("Preencha o campo SLUG do cardápio");
      setIsErrorSlug(true);
      return false;
    }

    if (alias === store.alias) return true;

    try {
      //TODO: Change URL
      await api.get(`https://api.mindi.com.br/store/data`, {
        headers: { url: alias },
      });
      setSlugErrorMessage("Essa url já está em uso. Tente outra, por favor.");
      setIsErrorSlug(true);
      return false;
    } catch (err) {
      return true;
    }
  }

  if (!store) return null;

  return (
    <Form onSubmit={handleSubmitBasicConfig}>
      <InputGroup>
        <label htmlFor="link-menu">Link do cardápio</label>
        <LinkInput
          value={alias || ""}
          onChange={handleAliasChange}
          id="link-menu"
          type="text"
          name="alias"
        />
        {isErrorSlug && (
          <span style={{ color: "red", fontSize: "12px" }}>
            {slugErrorMessage}
          </span>
        )}
      </InputGroup>
      <InputGroup>
        <label htmlFor="store-whatsapp">Whatsapp para receber pedido</label>
        <TextField
          value={phoneMask(whatsapp || "55")}
          onChange={(event) =>
            handleWhatsappChange(
              insertDDI(removeNoNumbersCharactersFromChangeEvent(event))
            )
          }
          id="store-whatsapp"
          type="text"
          name="whatsapp"
          required
          autoComplete="off"
          variant='outlined'
          size='small'
          style={{width:'230px'}}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <WhatsAppIcon />
              </InputAdornment>
            ),
          }}
        />
      </InputGroup>
      <hr />
      <ContainerButtonSubmit>
        <Button variant="contained" color="primary" type="submit">
          Salvar
        </Button>
        {loading === 1 && store.isLoading && (
          <Spinner type="grow" color="primary" />
        )}
      </ContainerButtonSubmit>
    </Form>
  );
}

export default BasicConfig;
